var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { arrayOf, number, object, oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import React, { Component } from 'react';
import PainScaleAPI from './pain-scale-api';
import { PainScaleType } from './pain-scale-type';
import PainScaleVisual from './pain-scale-visual';
import './pain-scale.css';
import { ToastService } from '@philips-internal/oswald-ui-components';
let PainScaleFaces = class PainScaleFaces extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            scaleOpen: false,
            value: undefined,
        };
        this.onSave = (value) => {
            if (isNaN(value)) {
                ToastService.open({
                    dismissible: true,
                    id: 'pain-scale-no-value',
                    level: ToastLevel.ERROR,
                    message: 'tws.pain-scale.save-value-toast-error',
                    placement: Placement.BOTTOM,
                    timeout: 5000,
                    type: ToastType.BANNER,
                });
            }
            this.setState({ scaleOpen: false, value: String(value) });
            return Promise.resolve(true);
        };
    }
    static { this.propTypes = {
        data: arrayOf(object).notEnumerable(),
        type: oneOf(enumValues(PainScaleType)),
        width: number.group('size')
    }; }
    renderScale() {
        const { selectedValue, value } = this.state;
        const { type } = this.props;
        return (React.createElement(PainScaleVisual, { onSave: this.onSave, scaleType: type, selectedValue: selectedValue, value: value }));
    }
    render() {
        return (React.createElement("div", { className: "c-pain-scale" }, this.renderScale()));
    }
};
PainScaleFaces = __decorate([
    AwesomeComponent({ api: PainScaleAPI, type: ComponentType.DATA_ENTRY })
], PainScaleFaces);
export default PainScaleFaces;
//# sourceMappingURL=pain-scale-faces.js.map